// Your web app's Firebase configuration
import { Firebase, SWFirebaseMessaging } from '@frontend/firebase';
import { FirebaseOptions } from 'firebase/app';
import { Messaging } from 'firebase/messaging';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig: FirebaseOptions = {
    apiKey: process.env['NX_PUBLIC_FIREBASE_API_KEY'],
    authDomain: process.env['NX_PUBLIC_FIREBASE_AUTH_DOMAIN'],
    projectId: process.env['NX_PUBLIC_FIREBASE_PROJECT_ID'],
    storageBucket: process.env['NX_PUBLIC_FIREBASE_STORAGE_BUCKET'],
    messagingSenderId: process.env['NX_PUBLIC_FIREBASE_MESSAGING_SENDER_ID'],
    appId: process.env['NX_PUBLIC_FIREBASE_APP_ID'],
    measurementId: process.env['NX_PUBLIC_FIREBASE_MEASUREMENT_ID']
};
export const vapidKey = process.env['NX_PUBLIC_FIREBASE_VAPID_KEY'];

// Initialize Firebase
const app = Firebase.getInstance(firebaseConfig).getApp();
// Messaging service — resolves to null when IndexedDB is unavailable (e.g. private browsing)
export const messaging: Promise<Messaging | null> = SWFirebaseMessaging.getInstance(app).then((i) => i.getMessaging());
